import { render, staticRenderFns } from "./MyProducts.vue?vue&type=template&id=e36ec420&scoped=true"
import script from "./MyProducts.vue?vue&type=script&lang=js"
export * from "./MyProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36ec420",
  null
  
)

export default component.exports